// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3wfWL","filesListContainer":"PosDisputesFiles_filesListContainer__3qQsj","filesButton":"PosDisputesFiles_filesButton__WNiuU"};